<script>
    import LoadingMessage from "$/pages/_templates/LoadingMessage.svelte";
    import { createEventDispatcher } from "svelte";

    let dispatch = createEventDispatcher();
</script>

<!-- The Same Design will be missing for Login Panel, figure it out
<div class="card-header">
    <span class="card-header__title">Save highlight</span>
    <div class="card-header__close" on:click={()=>dispatch("close")}>
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
    </div>
</div> -->
<div class="py-16">
    <LoadingMessage>
        <slot></slot>
    </LoadingMessage>
</div>

<style>
    @import "../../main.css";

    .card-header {
        @apply reset z-10 flex h-6 flex-shrink-0 items-center justify-between gap-1 rounded-t-xl border-l border-r border-t border-solid border-gray-200 bg-gray-100 px-4 !important;
    }

    .card-header__title {
        @apply reset m-0 block flex-1 items-center truncate bg-transparent text-xs text-gray-400 no-underline outline-none hover:text-gray-600 !important;
    }

    .card-header__close svg {
        @apply h-4 w-4 cursor-pointer text-gray-400 hover:text-black !important;
    }
</style>
